import { store } from '../../../redux/store'
import NewsService from "../NewsService";
import { dataChanged } from './newsListSlice'
import ArrayUtils from "../../../utils/ArrayUtils";
import RequestQueue from "../../../utils/net/RequestQueue";

let isInitialized = false
let queue;

if (!isInitialized) {
    isInitialized = true
    queue = new RequestQueue()
    queue.subscribe({
        success: function (r) {
            const state = store.getState()

            if (state.newsList.requestParams.offset > 0) {
                r.data.items = ArrayUtils.merge(state.newsList.data.items, r.data.items, (i) => i.id)
            }

            store.dispatch(dataChanged(r.data))
        },
        error: function (r) {
            // TODO: rozwazyc powiadomienie uzytkownika o bledzie.
            console.error(r)
        },
        complete: function (r) {
            console.debug('Stream of news list request has been completed.')
        }
    })
}

const NewsListDataManager = {
    load: function() {
        const state = store.getState()
        queue.addRequest(NewsService.findNews(state.newsList.requestParams))
    }
}

export default NewsListDataManager